import MuiAlert from "@mui/lab/Alert";
import { Button, Snackbar, TextField } from "@mui/material";
import { Component } from "react";

import AuthenticationActionCreator from "../../controller/action/AuthenticationActionCreator";
import AutheticationStore from "../../controller/store/AuthenticationStore";

import loginJalia from "../../assets/images/login-jalia.png";
import login from "../../assets/images/login.png";

import LoadingComponent from "../utils/LoadingComponent";
import DialogEstablishmentComponent from "./DialogEstablishmentComponent";

import Establishment from "../../controller/model/Establishment";
import Environment from "../../utils/Environement";

const _updateState = () => {
  const establishments = AutheticationStore.establishments;

  return {
    establishments: establishments,
  };
};

interface AuthenticationContainerInterface {
  establishments: Establishment[];
  isLoading: boolean;
  showEstablishment: boolean;
  showError: boolean;
  message: string | undefined;
}

const defaultState: AuthenticationContainerInterface = {
  establishments: AutheticationStore.establishments,
  isLoading: false,
  showEstablishment: false,
  showError: false,
  message: undefined,
};

class AuthenticationContainer extends Component {
  private email: string;
  private password: string;
  public state!: AuthenticationContainerInterface;

  constructor(props: any) {
    super(props);
    this.state = defaultState;
    this.email = "";
    this.password = "";
    this._handleStoreChange = this._handleStoreChange.bind(this);
    this.handleTapLloginButton = this.handleTapLloginButton.bind(this);
    this._handleEmailTextfieldChange = this._handleEmailTextfieldChange.bind(
      this
    );
    this._handlePasswordTextfieldChange = this._handlePasswordTextfieldChange.bind(
      this
    );
    this._handleSelectEstablishment = this._handleSelectEstablishment.bind(
      this
    );
    this._handleCloseSnackBar = this._handleCloseSnackBar.bind(this);
  }

  _handleStoreChange() {
    this.setState(_updateState());
  }

  componentDidMount() {
    AutheticationStore.addChangeListener(this._handleStoreChange);
  }

  componentWillUnmount() {
    AutheticationStore.removeChangeListener(this._handleStoreChange);
  }

  private handleTapLloginButton() {
    this.setState({ isLoading: true });
    AuthenticationActionCreator.loginWithEmailAndPassword(
      this.email,
      this.password
    )
      .then(() => {
        this.setState({
          isLoading: false,
          showEstablishment: true,
        });
      })
      .catch((err: any) => {
        console.warn(err);
        this.setState({
          showError: true,
          message:
            "Erreur de Login, veuillez vérifier votre e-mail et mot de passe",
          isLoading: false,
        });
      });
  }

  _handleEmailTextfieldChange(event: any) {
    this.email = event.target.value;
  }

  _handlePasswordTextfieldChange(event: any) {
    this.password = event.target.value;
  }

  _handleSelectEstablishment(establishment: Establishment) {
    this.setState({ showEstablishment: false, isLoading: true });
    AuthenticationActionCreator.selectEstablishment(establishment)
      .then(() => {
        (this.props as any).history.push("/home");
      })
      .catch((err: any) => {
        console.warn(err);
        this.setState({
          showError: true,
          message: "erreur lors de la récupération de l'établissement",
          isLoading: false,
        });
      });
  }

  _handleCloseSnackBar() {
    this.setState({ showError: false, message: undefined });
  }

  render() {
    return (
      <div>
        <div
          style={{
            width: "100%",
            padding: "12px",
            backgroundColor: "#474F5E",
          }}
        ></div>
        <div style={{ display: "flex" }}>
          {(Environment.isPopina)
            ? <img alt="login" src={login} style={{ width: "50%" }} />
            : <img alt="login" src={loginJalia} style={{ width: "50%" }} />
          }
          <Snackbar
            open={this.state.showError}
            autoHideDuration={6000}
            onClose={this._handleCloseSnackBar}
          >
            <MuiAlert severity="error" onClose={this._handleCloseSnackBar}>
              {this.state.message}
            </MuiAlert>
          </Snackbar>
          <DialogEstablishmentComponent
            establishments={this.state.establishments}
            handleSelectEstablishment={this._handleSelectEstablishment}
            isOpen={
              this.state.establishments.length !== 0 &&
              this.state.showEstablishment
            }
          />
          <LoadingComponent isOpen={this.state.isLoading} />
          <div
            style={{
              width: "50%",
              marginTop: "8em",
              marginLeft: "3em",
              marginRight: "2em",
              padding: "30px",
            }}
          >
            <div id="form-content">
              {
                (Environment.isPopina)
                  ? <div></div>
                  : <h2
                    style={{
                      fontSize: "50px",
                      textAlign: "left",
                      color: "#ffd400",
                    }}
                  >
                    Delivera
                </h2>
              }
              <h2
                style={{
                  fontSize: "40px",
                  textAlign: "left",
                  color: "#474F5E",
                }}
              >
                Se connecter
              </h2>
              <div style={{ padding: "30px 0" }}>
                <TextField
                  id="email-textfield"
                  label="Email"
                  fullWidth={true}
                  onChange={this._handleEmailTextfieldChange}
                  variant="outlined"
                  InputProps={{
                    style: {
                      fontSize: 22,
                    },
                  }}
                  InputLabelProps={{
                    style: {
                      color: "#474F5E",
                    },
                  }}
                />
              </div>
              <TextField
                variant="outlined"
                id="password-textfield"
                label="Mot de passe"
                InputProps={{ style: { fontSize: 22 } }}
                InputLabelProps={{
                  style: {
                    color: "#474F5E",
                  },
                }}
                fullWidth={true}
                type="password"
                onChange={this._handlePasswordTextfieldChange}
              />
            </div>
            <div style={{ marginTop: "40px", textAlign: "right" }}>
              <Button
                color="secondary"
                variant="contained"
                onClick={this.handleTapLloginButton}
                style={{ color: "white" }}
              >
                Se connecter
              </Button>
            </div>
            <br />
          </div>
        </div>
      </div>
    );
  }
}

export default AuthenticationContainer;
